class PageFavourites extends window.BAO.CustomElement() {
  connectedCallback () {
    if (this.els?.item?.elements?.length < 2) return

    this.setupSmoothScrollForHeadings()
    this.setupIntersectionObserver()
  }

  setupIntersectionObserver () {
    const options = {
      root: null,
      threshold: 0.25,
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.updateActiveHeading(entry.target.id)
        }
      })
    }, options)

    this.els?.item?.elements.forEach(item => {
      observer.observe(item)
    })
  }

  updateActiveHeading (id) {
    this.els?.title?.elements.forEach(heading => {
      const isActive = heading.getAttribute('href') === `#${id}`
      if (window.innerWidth > 999) {
        // Desktop version
        const description = heading.nextElementSibling.classList.contains('pg-Favourites_HeadingDesc') && heading.nextElementSibling
        const container = heading.closest('.pg-Favourites_Heading')

        heading.setAttribute('aria-active', 'true')
        description && description.setAttribute('aria-active', isActive ? 'true' : 'false')
        container && container.setAttribute('aria-active', isActive ? 'true' : 'false')
      } else {
        // Mobile version
        heading.setAttribute('aria-active', isActive ? 'true' : 'false')
      }

      if (window.innerWidth > 999) return

      if (isActive) {
        const headingParentDiv = heading.closest('.pg-Favourites_Heading')
        if (headingParentDiv) {
          const scrollableContainer = this.querySelector('.pg-Favourites_Headings')
          const containerRect = scrollableContainer.getBoundingClientRect()
          const headingRect = headingParentDiv.getBoundingClientRect()

          const headingLeftRelativeToContainer = headingRect.left - containerRect.left + scrollableContainer.scrollLeft

          if (headingLeftRelativeToContainer < scrollableContainer.scrollLeft || headingLeftRelativeToContainer + headingRect.width > scrollableContainer.scrollLeft + containerRect.width) {
            const desiredScrollLeft = headingLeftRelativeToContainer - (containerRect.width / 2) + (headingRect.width / 2)
            scrollableContainer.scrollTo({ left: desiredScrollLeft, behavior: 'smooth' })
          }
        }
      }
    })
  }

  setupSmoothScrollForHeadings () {
    this.els?.title?.elements.forEach(heading => {
      heading.addEventListener('click', event => {
        event.preventDefault()

        const targetId = heading.getAttribute('href').replace('#', '')
        const targetElement = document.getElementById(targetId)

        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' })
        }
      })
    })
  }
}

if (!customElements.get('page-favourites')) {
  customElements.define('page-favourites', PageFavourites)
}
